import { getRecurly } from './recurly';
import { useEffect } from 'react';

const RECURLY_PUBLIC_KEY =
  REACT_RECURLY_PUBLIC_KEY || 'ewr1-fXAwuLeLE9lsEi1kXStbNx';

const configureRecurly = async () => {
  const Recurly = await getRecurly();

  Recurly.configure({
    publicKey: RECURLY_PUBLIC_KEY,
  });
};

export const useRecurlyForm = () => {
  useEffect(() => {
    configureRecurly();
  }, []);
};
